import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Value } from '../domain/models';
import { BaseMiscApiService } from 'src/app/_common/api/base-misc-api.service';
import { AppConstants } from '../../app.constants';

@Injectable({
    providedIn: 'root'
})
export class ValuesMiscApiService extends BaseMiscApiService
{
    constructor (
        http: HttpClient
    )
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlRept;
        this.segmentApi = '/rept/values';
    }

    getPredefinterval (): Observable<Value[]>
    {
        return this.getValues('/predefinterval');
    }

    getIntervaltype (): Observable<Value[]>
    {
        return this.getValues('/intervaltype');
    }

    getPeriodicity (): Observable<Value[]>
    {
        return this.getValues('/periodicity');
    }

    getNumbersFormats (): Observable<Value[]>
    {
        return this.get('/numbersformat');
    }

    private getValues (endpoint: string): Observable<Value[]>
    {
        return this.get(`${endpoint}`);
    }
}
